import { chain, zipObject } from 'lodash';

type ColumnConfig = {
  column: string;
  label: string;
};

const buildDownloadFieldList = (
  translator: any,
  activeDynamicColumns: ColumnConfig[]
): Record<string, Record<string, string>> => chain(activeDynamicColumns)
  .flatMap(({ column, label }) => column.split(',').map((raw) => {
    const [prefix, field] = raw.trim().split('.');
    return prefix && field ? { prefix, field, label } : null;
  }))
  .filter(
    (item): item is { prefix: string; field: string; label: string } => item !== null
  )
  .groupBy('prefix')
  .mapValues((items) => zipObject(
    items.map((x) => x.field),
    items.map((x) => translator(x.label))
  ))
  .value();

export default buildDownloadFieldList;
